import React, { useMemo, memo, useState } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import { useSelector, useDispatch } from "react-redux"
import { formatDateLocal, getUserTopRole } from "@/utils"
import Typography from "@material-ui/core/Typography"
import clsx from "clsx"
import Button from "@material-ui/core/Button"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import { Link as RouterLink } from "react-router-dom"
import globalUseStyles from "@/globalUseStyles"
import modalRedeploymentStatusHandler from "@/redux/actions/modalRedeploymentAction"
import { resetActivateProcess } from "@/redux/actions/activateProjectProcessAction"
import { sendReminder } from "@/apis"
import { updateProjectArchiveByProjectIdRequest, updateEmailReminders } from "@/redux/actions/projectAction"
import { CircularProgress, ClickAwayListener, Divider, Grid, Grow, MenuItem, MenuList, Paper, Popper, Tooltip } from "@material-ui/core"
import {
    AlarmOutlined,
    MenuOutlined,
    ArchiveOutlined,
    InfoOutlined,
    AlarmAdd,
    UnarchiveOutlined,
    PersonOutline,
    FlightTakeoffOutlined,
    FlightLandOutlined,
} from "@material-ui/icons"
import SendReminderDialog from "../common/SendReminderDialog"

const useStyles = makeStyles((theme) => ({
    projectBlock: {
        // margin: theme.spacing(2, 2),
        // boxShadow: "0 0 5px 4px rgb(222 222 222)",
        boxShadow: "0 0 7px 3px rgb(0 0 0 / 6%)",
        background: theme.palette.sparcaLightGrey.secondary,
        position: "relative",
        // width: "375px",
    },
    projectBlockAccountHolderOrManagerRole: {
        paddingBottom: "100px",
    },
    projectInnerBlock: {
        padding: theme.spacing(3, 2),
    },
    productTypeDetail: {
        color: "#000000",
    },
    projectDetailLabel: {
        fontWeight: 600,
        margin: theme.spacing(1, 0),
        flex: 1,
    },
    projectDetailTopLabel: {
        width: "220px",
        minWidth: "220px",
        flex: 1,
    },
    projectDetail: {
        fontWeight: 600,
        flex: 1,
        color: theme.palette.primary.main,
    },
    projectActiveStatus: {
        display: "flex",
        alignItems: "center",
        "&::after": {
            content: '""',
            width: "20px",
            height: "20px",
            marginLeft: "20px",
            display: "inline-block",
            borderRadius: "50%",
        },
    },
    activeStatusInactive: {
        backgroundColor: theme.palette.primary.main,
        height: "16px",
        width: "16px",
        borderRadius: "50%",
    },
    activeStatusCompleted: {
        backgroundColor: theme.palette.green.main,
        height: "16px",
        width: "16px",
        borderRadius: "50px",
    },
    activeStatusActive: {
        backgroundColor: theme.palette.blue.main,
        height: "16px",
        width: "16px",
        borderRadius: "50%",
    },
    activeStatusArchived: {
        backgroundColor: theme.palette.grey[700],
        height: "16px",
        width: "16px",
        borderRadius: "50%",
    },
    projectDetailBlockWrapper: {},
    projectDetailBlockButtonWrapper: {},
    projectDetailBlockInnerButtonWrapperStatus: {},
    sparcaProjectDetailButton: {
        width: "170px",
    },
    productBlockDetailWrapper: {},
    projectDetailBlock: {
        display: "flex",
        alignItems: "baseline",
    },
    projectDetailBlockBottomButtonWrapper: {
        position: "absolute",
        width: "calc(100% - 20px)",
        bottom: "10px",
    },
    projectDetailBlockBottomButton: {
        marginBottom: theme.spacing(4),
    },
    // Start
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "32px !important",
        padding: "24px",
        borderRadius: "8px",
        // boxShadow: "1px 1px 16px 0px #ccc",
        background: "#fff",
    },
    projectTitle: {
        fontWeight: 400,
        fontSize: "1.2rem",
    },
    [theme.breakpoints.up("xl")]: {
        projectTitle: {
            fontSize: "1rem",
        },
    },
    projectName: {
        fontWeight: 600,
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
    },
    cardBody: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        margin: "4px 0px",
    },
    cardFooter: {},
    label: {
        fontWeight: 600,
    },
    valueContainer: {
        display: "flex",
        gap: "8px",
        alignItems: "center",
    },
    statusCircle: {
        width: "12px",
        height: "12px",
        background: "green",
        borderRadius: "50px",
    },
    progressWrapper: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    progressBar: {
        flex: 1,
        margin: 0,
        borderRadius: "8px",
        height: "8px",
        color: "pink",
    },
    flexCol: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
    flexRow: {
        display: "flex",
        flexDirection: "row",
        gap: "4px",
        alignItems: "center",
    },
    menuIcon: {
        "&:hover": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            transition: ".2s all",
        },
    },
    titleContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        "&  $lastChild": { fontWeight: "bold" },
    },
    cardBodyGrid: {
        rowGap: "16px",
    },
    menuContainer: {
        display: "flex",
        alignItems: "flex-start",
    },
    progressHolder: {
        display: "flex",
        justifyContent: "space-between",
    },
    circularProgress: {
        background: "#eee",
        borderRadius: "50%",
    },
    divider: {
        width: "100%",
    },
}))

function CircularProgressWithLabel(props) {
    const classes = useStyles()

    const { finishedAssessments, totalParticipants } = props

    let progress = 0
    if (Number(totalParticipants) !== 0) {
        progress = (finishedAssessments / totalParticipants) * 100
    }

    return (
        <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center">
            <CircularProgress
                size="3rem"
                className={classes.circularProgress}
                variant="determinate"
                background="secondary"
                value={progress}
                thickness={4}
            />
            <Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
                <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(progress)}%`}</Typography>
            </Box>
        </Box>
    )
}

const ProjectDashboardContentBlock = memo((props) => {
    const [open, setOpen] = React.useState(false)
    const anchorRef = React.useRef(null)

    const [reminderDialogOpen, setReminderDialogOpen] = useState(false)

    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [requestSuccessStatus, setRequestSuccessStatus] = useState(true)
    const [snackbarMessage, setSnackbarMessage] = useState("")

    const { projectDetail } = props
    const classes = useStyles()
    const globalClasses = globalUseStyles()
    const userData = useSelector((state) => state.userReducer)
    const { user } = userData // signed up user
    const userRoleData = useSelector((state) => state.userRoleReducer)
    const { userRolesArray } = userRoleData
    const loginUserRoles = userRolesArray.find((userRoleItem) => userRoleItem.userId === user.userId).userRoles
    const topRole = useMemo(() => getUserTopRole(loginUserRoles), userRolesArray)
    const accountHolderOrManagerRole = topRole.roleName === process.env.PROJECT_MANAGER || topRole.roleName === process.env.ACCOUNT_HOLDER
    const dispatch = useDispatch()
    const {
        projectId,
        productName,
        projectLaunchDate,
        projectName,
        projectReportDate,
        projectReportLink,
        projectSponsor,
        projectStartDate,
        projectArchive,
        projectTotalParticipant,
        finishedAssessments,
        emailReminders,
    } = projectDetail

    const handleRedeployProject = () => {
        dispatch(
            modalRedeploymentStatusHandler({
                modalRedeploymentProject: projectDetail,
                currentStep: 1,
                modalRedeploymentShow: true,
            })
        )
        dispatch(resetActivateProcess)
    }

    const handleArchive = async (archiveStatus) => {
        await dispatch(updateProjectArchiveByProjectIdRequest({ projectId, archiveStatus }))
        setOpen(false)
        showSnackbar(`Project has been ${archiveStatus ? "Archived" : "Unarchived"}`)
    }

    const showSnackbar = (message, status = true) => {
        setSnackbarMessage(message)
        setRequestSuccessStatus(status)
        setSnackbarOpen(true)
    }

    const handleSnackbarOpenStatus = (status) => {
        setSnackbarOpen(status)
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event, extraAction) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
        if (extraAction) extraAction()
    }

    const handleListKeyDown = (event) => {
        if (event.key === "Tab") {
            event.preventDefault()
            setOpen(false)
        }
    }

    const handleSendReminder = async (projectIdReminder) => {
        await sendReminder(projectIdReminder)
        setReminderDialogOpen(false)
        showSnackbar(`Email Reminder sent to all particpnats`)
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = open
    }, [open])

    const handleToggleEmailReminder = async (projectIdEmailReminder, status) => {
        const result = await dispatch(updateEmailReminders(projectIdEmailReminder, status))
        if (result) {
            showSnackbar(`Email reminders turned ${!status ? "OFF" : "ON"} for project id ${projectIdEmailReminder}`)
        } else {
            showSnackbar(`Something wrong, action is failed`, false)
        }
        setOpen(false)
    }

    const getProjectStatus = useMemo(() => {
        if (projectArchive) return "Archived"
        if (!projectStartDate) return "Not Active"
        if (projectLaunchDate) return "Completed"
        return "Active"
    }, [projectArchive, projectStartDate, projectLaunchDate])

    return (
        <>
            <Box
                className={clsx(classes.root, classes.projectBlock, {
                    [classes.projectBlockAccountHolderOrManagerRole]: accountHolderOrManagerRole,
                })}
                // id={`project-${projectId}`}
                // data-archive={!!projectDetail.projectArchive}
                // data-completed={projectDetail.projectLaunchDate ? true : false}
            >
                <Box className={classes.cardHeader}>
                    <Box className={classes.titleContainer}>
                        <Typography className={classes.projectName} variant="h6">
                            {projectName}
                        </Typography>
                        <Typography className={classes.projectTitle}>{productName}</Typography>
                    </Box>
                    {!projectLaunchDate && (
                        <Box className={classes.menuContainer}>
                            {/* Some component here in fuure, Maybe? */}
                            <MenuOutlined
                                ref={anchorRef}
                                aria-controls={open ? "menu-list-grow" : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}
                                className={classes.menuIcon}
                                fontSize="default"
                            />
                            <Popper
                                style={{ zIndex: 1 }}
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                transition
                                disablePortal
                            >
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                    <MenuItem
                                                        className={classes.valueContainer}
                                                        onClick={() => handleToggleEmailReminder(projectId, !emailReminders)}
                                                    >
                                                        <AlarmAdd fontSize="small" />
                                                        Turn Reminders {emailReminders ? "Off" : "On"}
                                                    </MenuItem>
                                                    <MenuItem
                                                        className={classes.valueContainer}
                                                        onClick={(e) => handleClose(e, setReminderDialogOpen(true))}
                                                    >
                                                        <AlarmOutlined fontSize="small" />
                                                        Send Reminder
                                                    </MenuItem>
                                                    {!projectArchive ? (
                                                        <MenuItem className={classes.valueContainer} onClick={() => handleArchive(true)}>
                                                            <ArchiveOutlined fontSize="small" />
                                                            Archive
                                                        </MenuItem>
                                                    ) : (
                                                        <MenuItem className={classes.valueContainer} onClick={() => handleArchive(false)}>
                                                            <UnarchiveOutlined fontSize="small" />
                                                            Unarchive
                                                        </MenuItem>
                                                    )}
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </Box>
                    )}
                </Box>
                <Box className={classes.cardBody}>
                    <Grid container spacing={2} className={classes.cardBodyGrid}>
                        <Grid item className={classes.flexCol} xs={6}>
                            <Typography className={classes.label}>Status</Typography>
                            <Box display="flex" gridGap={4}>
                                <Box>
                                    <Box
                                        className={clsx(classes.projectDetail, classes.projectActiveStatus, {
                                            [classes.activeStatusArchived]: projectArchive,
                                            [classes.activeStatusInactive]: !projectStartDate,
                                            [classes.activeStatusCompleted]: projectStartDate && projectLaunchDate,
                                            [classes.activeStatusActive]: projectStartDate && !projectLaunchDate,
                                        })}
                                    />
                                </Box>
                                <Typography color="secondary">{getProjectStatus}</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6} className={`${classes.valueContainer} ${classes.progressHolder}`}>
                            <Box className={classes.flexCol}>
                                <Typography className={classes.label}>Progress</Typography>
                                <Box className={classes.valueContainer}>
                                    <Typography color="secondary">
                                        {finishedAssessments || 0}/{projectTotalParticipant || 0}
                                    </Typography>
                                    <Tooltip title="Progress is the percentage of total number of participants that finished the assessment to the total number of participants invited to take part in the assessment.">
                                        <InfoOutlined style={{ fontSize: "1.1rem" }} />
                                    </Tooltip>
                                </Box>
                            </Box>
                            <Box>
                                <CircularProgressWithLabel
                                    finishedAssessments={finishedAssessments}
                                    totalParticipants={projectTotalParticipant}
                                />
                            </Box>
                        </Grid>

                        <Divider className={classes.divider} />

                        <Grid item className={classes.flexRow} xs={6}>
                            <PersonOutline fontSize="small" />
                            <Typography className={classes.label}>Sponsor</Typography>
                        </Grid>
                        <Grid item className={classes.flexCol} xs={6}>
                            <Typography color="secondary">{projectSponsor}</Typography>
                        </Grid>

                        <Grid item className={classes.flexRow} xs={6}>
                            <FlightTakeoffOutlined fontSize="small" />
                            <Typography className={classes.label}>Start Date</Typography>
                        </Grid>
                        <Grid item className={classes.flexCol} xs={6}>
                            <Typography color="secondary">{projectStartDate ? formatDateLocal(projectStartDate) : "-"}</Typography>
                        </Grid>

                        <Grid item className={classes.flexRow} xs={6}>
                            <FlightLandOutlined fontSize="small" />
                            <Typography className={classes.label}>Close Date</Typography>
                        </Grid>
                        <Grid item className={classes.flexCol} xs={6}>
                            <Typography color="secondary">{projectLaunchDate ? formatDateLocal(projectLaunchDate) : "-"}</Typography>
                        </Grid>
                        <Divider className={classes.divider} />
                    </Grid>
                </Box>
                <Box className={classes.cardFooter}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            {accountHolderOrManagerRole && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={!projectLaunchDate}
                                    fullWidth
                                    onClick={handleRedeployProject}
                                >
                                    REDEPLOY
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            {projectLaunchDate && projectReportDate && projectReportLink ? (
                                <a
                                    className={globalClasses.buttonLink}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={`${projectReportLink}`}
                                >
                                    <Button variant="outlined" color="primary" fullWidth>
                                        Results
                                    </Button>
                                </a>
                            ) : (
                                <Button variant="contained" color="primary" disabled fullWidth>
                                    Results
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            {!projectLaunchDate ? (
                                <RouterLink to={`/project/${projectId}/`} className={globalClasses.buttonLink}>
                                    <Button variant="outlined" color="primary" fullWidth>
                                        Control Panel
                                    </Button>
                                </RouterLink>
                            ) : (
                                <Button variant="contained" color="primary" disabled fullWidth>
                                    Control Panel
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <RequestSnackbar
                status={requestSuccessStatus}
                message={snackbarMessage}
                snackbarOpen={snackbarOpen}
                handleSnackbarOpenStatus={handleSnackbarOpenStatus}
            />

            <SendReminderDialog
                handleModalClose={() => setReminderDialogOpen(false)}
                open={reminderDialogOpen}
                title="Send Reminder"
                description={
                    <Typography gutterBottom>Are you sure you want to send a reminder to all the participants of this project?</Typography>
                }
                sendAction={() => handleSendReminder(projectId)}
            />
        </>
    )
})

export default ProjectDashboardContentBlock
